import { render, staticRenderFns } from "./resetPass.vue?vue&type=template&id=91ff4bfc&scoped=true&"
import script from "./resetPass.vue?vue&type=script&lang=js&"
export * from "./resetPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ff4bfc",
  null
  
)

export default component.exports